const isAlphanumeric = (val, dashes = true) => {
    if(dashes) {
        return /^[a-z0-9-]*$/gmi.test(val);
    } else {
        return /^[a-z0-9]*$/gmi.test(val);
    }
};

export default {
    isLengthBetween: (val, min, max) => {
        if(!val) return false;
        return val.length <= max && val.length >= min;
    },
    isAboveMaxLength: (val, max) => {
        return val.length > max;
    },
    isAlphanumeric,
    isPhoneNumber: val => /^[\d-+()\s+]{5,12}$/gmi.test(val),
    isWithinLimit: (val, min, max) => {
        if(!val) return false;
        return val <= max && val >= min;
    },
    email: email => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(String(email).toLowerCase()),
    password: value => {
        if(!value || value.length < 8 || value.length > 64) return false; //Between 8 and 64 chars
    
        if(!(/\d/gmi.test(value))) return false; //At least one number
        if(!(/[A-Z]/gm.test(value))) return false; //At least one uppercase letter
        if (isAlphanumeric(value)) return false; //At least one alphanumeric letter
        return true;
    }
};
